import Vue from "vue"
import Buefy from "buefy"
import ContactDetail from "./App.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(ContactDetail)

if (document.getElementById("contactDetailApp")){
    new Vue({
        render:h=>h(
            ContactDetail,{
                props:{
                    detailUrl:document.getElementById("contactDetailApp")
                        .getAttribute("detail-url")
                }
            }
        )
    }).$mount("#contactDetailApp")
}